module.exports = __webpack_public_path__ + "img/selectIcon.875116bc.svg";